<template>
  <div class="header-wrapper-430">
    <Form
      ref="searchForm"
      :model="formInline"
      label-position="right"
      :label-width="0"
      inline
      style="position: relative; margin-bottom: 8px"
      class="search-list-430 search-wrapper-430"
    >
      <FormItem label="">
        <Input
          v-model="materialValue"
          placeholder="请输入"
          clearable
          class="search-selectInput-430"
        >
          <Select
            slot="prepend"
            v-model="materiaSelectValue"
            placeholder="请选择名称/ID"
            class="search-select-430"
          >
            <Option value="1">材料名称</Option><Option value="2">材料ID</Option>
          </Select></Input
        >
      </FormItem>

      <FormItem label="">
        <ChooseApply
          :placeholder="`请选择课程提供方`"
          :yearTermCode="[formInline.yearCode, formInline.termCode]"
          :clearable="true"
          :orgType="``"
          ref="chooseApplyRef"
          v-if="portOrg != 3"
        ></ChooseApply>
        <p v-else>{{ userInfo && userInfo.orgName }}</p>
      </FormItem>
      <FormItem label="">
        <ChooseApply
          :placeholder="`请选择学校`"
          :yearTermCode="[formInline.yearCode, formInline.termCode]"
          :clearable="true"
          :orgType="`1`"
          ref="chooseSchoolRef"
          v-if="portOrg != 2"
        ></ChooseApply>
        <p v-else>{{ userInfo && userInfo.orgName }}</p>
      </FormItem>
      <FormItem label="">
        <CascaderYearTerms
          ref="cascaderYearTerms"
          :placeholder="`请选择学期`"
          @on-init="handleSearch"
          @on-change="onCascaderChange"
        ></CascaderYearTerms>
      </FormItem>
      <FormItem label="">
        <Input
          v-model="classroomValue"
          placeholder="请输入"
          clearable
          class="search-selectInput-430"
        >
          <Select
            slot="prepend"
            v-model="classroomSelectValue"
            placeholder="请选择名称/ID"
            class="search-select-430"
          >
            <Option value="1">商品名称</Option><Option value="2">商品ID</Option>
          </Select></Input
        >
      </FormItem>

      <FormItem>
        <Select
          v-model="formInline.classroomState"
          placeholder="材料上架状态"
          clearable
          class="search-select-430"
        >
          <Option value="4">已上架</Option>
          <Option value="0">已下架</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select
          v-model="formInline.isVisible"
          placeholder="是否可见"
          clearable
          class="search-select-430"
        >
          <Option value="1">是</Option>
          <Option value="0">否</Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="handleSearch">查询</Button>
      <Button class="search-430" @click="handleReset">重置</Button>
    </Form>

    <div class="action-main flex justify-content_end">
      <Button @click="handleExport">导出Excel</Button>
    </div>
  </div>
</template>

<script>
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';

import ChooseApply from '@c/searchBlock/ChooseApply.vue';
export default {
  components: {
    CascaderYearTerms,
    ChooseApply
  },
  data() {
    return {
      materialValue: '',
      materiaSelectValue: '1',
      classroomValue: '',
      classroomSelectValue: '1',

      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      portOrg: Number(localStorage.getItem('portOrg')),
      formInline: {
        schoolId: '',
        yearCode: '',
        termCode: '',
        classroomState: '',
        isVisible: '',
      }
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.portOrg === 2) {
        this.formInline.schoolId = localStorage.getItem('schoolId')
      }

    });
  },
  methods: {
    handleSearch() {
      this.$emit('on-search', this.getParameter())
    },
    handleExport() {
      this.$emit('on-export', this.getParameter())
    },
    // 重置
    handleReset() {
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear()
      this.$refs.chooseSchoolRef && this.$refs.chooseSchoolRef.handleClear()
      this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault()
      this.materialValue = ''
      this.materiaSelectValue = '1'
      this.classroomValue = ''
      this.classroomSelectValue = '1'
      for (let k in this.formInline) {
        this.formInline[k] = ''
      }
      if (this.portOrg === 2) {
        this.formInline.schoolId = localStorage.getItem('schoolId')
      }
      this.handleSearch()
    },
    onSchChange(info) {
      this.formInline.schoolId = info.schoolId == -1 ? '' : info.schoolId
      console.log(info.schoolId);
    },
    onCascaderChange(val) {
      this.formInline.yearCode = val[0];
      this.formInline.termCode = val[1];
      this.$nextTick(() => {
        this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear()
        this.$refs.chooseSchoolRef && this.$refs.chooseSchoolRef.handleClear()
      })
    },
    getParameter() {
      const yearTerms = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.getResult();
      this.formInline.orgId = this.portOrg != 3 ? this.$refs.chooseApplyRef.getResult().orgId : this.userInfo.orgId
      this.formInline.schoolId = this.portOrg != 2 ? this.$refs.chooseSchoolRef.getResult().orgId : this.userInfo.orgId
      let { schoolId, isVisible, classroomState, orgId } = this.formInline

      return {
        materialId: this.materiaSelectValue == 2 ? this.materialValue : '',
        offerName: this.materiaSelectValue == 1 ? this.materialValue : '',
        orgId,
        schoolId,
        yearCode: yearTerms[0],
        termCode: yearTerms[1],
        classroomId: this.classroomSelectValue == 2 ? this.classroomValue : '',
        classroomName: this.classroomSelectValue == 1 ? this.classroomValue : '',
        classroomState,
        isVisible
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-wrapper-430 {
  margin-bottom: 8px;
}
</style>